const settings = {
  language: "שפה",
  hebrew: "עברית",
  english: "אנגלית",
  russian: "רוסית",
  sidebarPosition: "מיקום סרגל צד",
  right: "ימין",
  left: "שמאל",
  sidebarVisibility: "נראות סרגל צד",
  visible: "גלוי",
  float: "צף",
  hidden: "מוסתר",
  themeMode: "ערכת נושא",
  themeModeDark: "כהה",
  themeModeLight: "בהיר",
  theme: "עיצוב",
  accentColor: "צבע מבטא",
  fontFamily: "גופן",
  borderRadius: "עיגול פינות",
  density: "צפיפות",
  textSize: "גודל טקסט",
  textNormal: "רגיל",
  textLarge: "גדול",
  textXLarge: "גדול מאוד",
  sharp: "חד",
  default: "ברירת מחדל",
  round: "עגול",
  compact: "צפוף",
  spacious: "מרווח",
  heebo: "Heebo",
  geist: "Geist",
  inter: "Inter",
  system: "מערכת",
  openSettings: "פתח הגדרות",
  tabGeneral: "כללי",
  tabTheme: "עיצוב",
  tabBrand: "מותג",
  tabWidgetBar: "סרגל ווידג'טים",
  activeProfile: "פרופיל פעיל",
  noActiveProfile: "ללא פרופיל",
  profileModified: "(שונה)",
  saveNewProfile: "שמור כפרופיל חדש",
  profileNamePlaceholder: "שם הפרופיל...",
  savedProfiles: "פרופילים שמורים",
  noProfiles: "אין פרופילים שמורים",
  loadProfile: "טען",
  renameProfile: "שנה שם",
  overwriteProfile: "עדכן פרופיל",
  updateProfile: "עדכון פרופיל קיים",
  builtIn: "מובנה",
  profileDefault: "ברירת מחדל",
  profileMinimal: "מינימלי",
  profileLoaded: "פרופיל נטען",
  profileSaved: "פרופיל נשמר",
  profileDeleted: "פרופיל נמחק",
  colorPicker: "בוחר צבע",
  myPalette: "הפלטה שלי",
  noSavedColors: "אין צבעים שמורים",
  colorCombos: "שילובי צבעים",
  effects: "אפקטים",
  gradient: "גרדיאנט",
  gradientDirection: "כיוון",
  secondaryColor: "צבע משני",
  glow: "זוהר",
  glowIntensity: "עוצמה",
  subtle: "עדין",
  medium: "בינוני",
  strong: "חזק",
  useAsAccent: "השתמש כצבע מבטא",
  saveToPalette: "שמור בפלטה",
  custom: "מותאם",
  on: "פעיל",
  off: "כבוי",
  comboSunset: "שקיעה",
  comboOcean: "אוקיינוס",
  comboAurora: "זוהר צפוני",
  comboForest: "יער",
  comboFlame: "להבה",
  comboRoyal: "מלכותי",
  comboMidnight: "חצות",
  comboRoseGold: "זהב ורוד",
  comboGlacier: "קרחון",
  lockColor: "נעל צבע",
  unlockColor: "בטל נעילה",
  useAsBrand: "השתמש כצבע מותג",
  removeColor: "הסר צבע",
  colorArchive: "מחסן צבעים",
  noArchivedColors: "אין צבעים במחסן",
  restoreColor: "שחזר",
  deletePermanently: "מחק לצמיתות",
  navColor: "צבע ניווט",
  navColorHint: "צבע רקע לסרגל צד וסרגל עליון",
  resetNavColor: "איפוס (עוקב אחרי ערכת הצבעים)",
  colorTheme: "ערכת צבעים",
  darkThemes: "כהה",
  lightThemes: "בהיר",
  tabPwa: "PWA",
  gibberishDetect: "זיהוי מקלדת שגויה",
  gibberishDetectHint: "זיהוי אוטומטי כשמקלידים בשפה הלא נכונה",
  gibberishMeantHebrew: "האם התכוונת לעברית?",
  gibberishMeantEnglish: "Did you mean English?",
  gibberishConvert: "המר",
  tabAccounts: "חיבורים",
  tabEmailTemplates: "תבניות מייל",
  tabProfile: "פרופיל",
  tabSearch: "חיפוש",
  tabSystem: "מערכת",
  tabUsers: "משתמשים",
  tabLogin: "התחברות",
  tabShortcuts: "קיצורים",
  connectedAccounts: "חשבונות מחוברים",
  connectGoogle: "חבר חשבון Google",
  googleSection: "Google",
  scopeGmail: "Gmail",
  scopeCalendar: "לוח שנה",
  disconnect: "נתק",
  disconnectConfirm: "בטוח שברצונך לנתק חשבון זה?",
  accountConnected: "החשבון חובר בהצלחה",
  accountDisconnected: "החשבון נותק",
  active: "פעיל",
  inactive: "מושבת",
  noAccounts: "אין חשבונות מחוברים",
  noAccountsHint: "חבר חשבון Google לגשת ל-Gmail ולוח שנה",
  // Integrations Hub
  integrationsTitle: "חיבורים ואינטגרציות",
  sectionAuthSecurity: "אימות ואבטחה",
  sectionCommunication: "שירותי תקשורת",
  sectionExternalServices: "שירותים חיצוניים",
  sectionMessaging: "הודעות",
  currentLoginMethod: "שיטת התחברות נוכחית",
  connectedProviders: "ספקי זהות מחוברים",
  linkProvider: "חבר",
  unlinkProvider: "נתק",
  noProviders: "אין ספקים מחוברים",
  otpEnabled: "קוד חד-פעמי מופעל",
  otpDisabled: "קוד חד-פעמי מושבת",
  webhookUrl: "כתובת Webhook",
  copied: "הועתק!",
  copyUrl: "העתק",
  configured: "מוגדר",
  notConfigured: "לא מוגדר",
  connected: "מחובר",
  comingSoon: "בקרוב",
  testConnection: "בדיקת חיבור",
  connectionOk: "החיבור תקין",
  connectionFailed: "החיבור נכשל",
  watiWhatsapp: "WATI — WhatsApp",
  voicenterPbx: "Voicenter — מרכזייה",
  origamiCrm: "Origami CRM",
  notionIntegration: "Notion",
  n8nAutomation: "n8n — אוטומציות",
  zapierIntegration: "Zapier",
  makeIntegration: "Make",
  smsCredits: "SMS (Twilio)",
  emailCredits: "Email (Resend)",
  providerEmail: "אימייל + סיסמה",
  providerOtp: "קוד חד-פעמי",
  providerGithub: "GitHub",
  providerFacebook: "Facebook",
  providerMicrosoft: "Microsoft",
  providerApple: "Apple",
  providerLinkedin: "LinkedIn",
  providerGoogle: "Google",
  tabSkins: "סקינים",
  skinsTitle: "סקינים — עיצוב התצוגה",
  skinsSubtitle: "בחר עיצוב לכל שכבה בנפרד",
  skinShellTitle: "מסגרת (Shell)",
  skinShellDesc: "סיידבר, טופבר, ניווט — המסגרת החיצונית של האפליקציה",
  skinContentTitle: "תוכן (Content)",
  skinContentDesc: "כרטיסיות, טבלאות, טפסים — עיצוב הדפים הפנימיים",
  skinMobileNavTitle: "ניווט מובייל",
  skinMobileNavDesc: "סגנון הניווט במסך קטן — תפריט תחתון, המבורגר ועוד",
  skinCurrent: "נוכחי",
  skinFeatures: "תכונות",
  skinSafetyNote: "בטיחות",
} as const;
export default settings;
